<script lang="ts">
    import { useLocation } from "svelte-navigator";
    import { get } from "svelte/store";
    import { appManager } from "../AppManager";

    export let optional: boolean;
    export let needsPlan: boolean;

    const location = useLocation();

    let hasUser: boolean = false;
    let hasPlan: boolean = false;

    async function getUser() {
        const user = get(await appManager.getCurrentUserStore());

        if (typeof user !== "undefined") {
            hasUser = true;
            if (needsPlan) {
                hasPlan = await appManager.hasActivePlan();

                if (!hasPlan) {
                    window.location.href = `${appManager.PublicUrl}notfound`;
                }
            }
        } else {
            hasUser = false;
            if (!optional) {
                window.location.href = `${
                    appManager.PublicUrl
                }signin?redirect=${$location.pathname + $location.hash}`;
            }
        }
    }
</script>

{#await getUser() then}
    {#if (hasUser || optional) && (!needsPlan || hasPlan)}
        <slot />
    {/if}
{/await}
